export default {
  action: {
    openCreate: {
      notes: 'Open create user dialog action',
      message: 'Add user without e-mail',
    },
  },
  roles: {
    header: {
      notes: 'Header in user role section',
      message: 'User roles',
    },
    helpText: {
      notes: 'Help text in user role section',
      message:
        'Please select one or more roles for this user. Refer to the table below to find out which permission levels are associated with each role.',
    },
    roleTableHeader: {
      notes: 'Header of roles table',
      message: 'Table of available user roles',
    },
    selectCompany: {
      notes: 'Company needs to be selected before assigning roles',
      message: 'Select a company before assigning roles',
    },
    validation: {
      notes: 'Validation message when no roles are selected',
      message: 'Select one or more roles',
    },
  },
  basicInformation: {
    notes: 'Header in basic information section',
    message: 'Basic information',
  },
};
